export default "__VITE_ASSET__BAroQokD__"